export class HateoasCompose {

    private _elementsMap: Map<string, HateoasComposeItem> = new Map<string, HateoasComposeItem>();

    static with(property: string, forceRefresh: boolean = false): HateoasCompose {
        const composer = new HateoasCompose();
        const hateoasComposeItem : HateoasComposeItem = new HateoasComposeItem(property, forceRefresh)
        composer._elementsMap.set(property, hateoasComposeItem);
        return composer;
    }

    public and(property: string, forceRefresh: boolean = false): HateoasCompose {
        const hateoasComposeItem : HateoasComposeItem = new HateoasComposeItem(property, forceRefresh)
        this._elementsMap.set(property, hateoasComposeItem);
        return this;
    }

    public build(): Map<string, HateoasComposeItem> {
        return this._elementsMap;
    }

}

export class HateoasComposeItem {
    private _property: string;
    private _forceRefresh: boolean;

    constructor(property: string, forceRefresh: boolean) {
        this._property = property;
        this._forceRefresh = forceRefresh;
    }

    public getProperty(): string {
        return this._property;
    }

    public getForceRefresh(): boolean {
        return this._forceRefresh;
    }

}
